//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import VerticalBarsChart from "@/components/Charts/VerticalBarsChart.vue";
import HorizontalBarsChart from "@/components/Charts/HorizontalBarsChart.vue";
import StoreRankingTable from "@/pages/FlashReport/components/StoreRankingTable.vue";
import ProductRankingTable from "@/pages/FlashReport/components/ProductRankingTable.vue";
import ViewGraphTable from "@/pages/FlashReport/components/GraphTable.vue";
import InsigniaTable from "@/pages/FlashReport/components/InsigniaTable.vue";
import TreemapTable from "@/pages/FlashReport/components/TreemapTable.vue";
import Treemap from "@/components/Charts/Treemap.vue";
import * as d3 from "d3";
import CalendarServices from "@/services/calendar-services.js";
import { EventBus } from "@/event-bus.js";
import ExportGraph from "@/services/export-graph.js";

export default {
  name: "GeneralViewTab",
  components: {
    HorizontalBarsChart,
    VerticalBarsChart,
    Treemap,
    StoreRankingTable,
    ProductRankingTable,
    ViewGraphTable,
    InsigniaTable,
    TreemapTable
  },
  props: [
    "selectedRetailer",
    "retailerList",
    "fields",
    "fieldId",
    "startDate",
    "endDate",
    "productHierarchyElementId",
    "storeHierarchyElementId",
    "geoHierarchyElementId",
    "productIds",
    "storeIds",
    "employeeIds",
    "employeeName",
  ],
  mounted: async function () {
    EventBus.$on("clear-dashboard", this.clearData);
  },
  data: () => ({
    moment,
    d3,
    CalendarServices,
    ExportGraph,
    verticalGraphExpanded: false,
    horizontalGraphExpanded: false,
    treemapGraphExpanded: false,
    storeRankingExpanded: false,
    productRankingExpanded: false,
    monthList: moment
      .months()
      .map((name) => name.charAt(0).toUpperCase() + name.slice(1)),
    mainVerticalGraphKey: null,
    runningRequests: 0,
    isShowingSpinner: false,
    secondaryVerticalGraphKey: null,
    mainHorizontalGraphKey: null,
    secondaryHorizontalGraphKey: null,
    productId: null,
    storeId: null,
    selectedTimePeriod: "Mês",
    datePeriod: "month",
    monthPicker: false,
    selectedMonth: null,
    treemapHierarchyId: null,
    hGraphHierarchyId: null,
    graphMode: {
      salesEvolution: true,
      treeMap: true,
      insigniaGraph: true
    },
    periodGraphSize: {
      width: 700,
    },
    insigniaGraph: {
      width: 1500,
    },
    treemapSize: {
      width: 700,
    },
    salesEvolution: {
      mainData: [],
      secondaryData: [],
      lineData: [],
      evaluatedMainDates: [],
      evaluatedSecondaryDates: [],
    },
    salesEvolutionMargin: {
      top: 30,
      right: 40,
      bottom: 30,
      left: 40,
    },
    productAggregationData: {
      children: [],
    },
    productAggregationMargin: {
      top: 30,
      right: 40,
      bottom: 30,
      left: 40,
    },
    productAggregationColorRange: [
      "#B53548",
      "#2E9E7E",
      "#006DB3",
      "#DE8033",
      "#E8D638",
    ],
    salesByStore: {
      mainData: [],
      secondaryData: [],
    },
    salesByStoreMargin: {
      top: 30,
      right: 40,
      bottom: 30,
      left: 150,
    },
    storeRankingData: [],
    productRankingData: [],
    isLoadingStoreRanking: false,
    isLoadingProductRanking: false,
    recordsTotalStoreRanking: 0,
    recordsTotalProductRanking: 0,
    productRankingPagination: {
      page: 1,
      rowsPerPage: 10,
    },
    storeRankingPagination: {
      page: 1,
      rowsPerPage: 10,
    },
    selectedBarMonth: null,
    selectedBarYear: null,
    selectedBarInsignia: null,
    selectedTreemap: null,
    export: null,
    isLoadingSalesEvolution: false,
    isLoadingSalesByStore: false,
    treeMapLoading: false,
    showTreeMap: false,
    treeMapSelectedText: {
      label: "",
      valueLabel: "",
      dataValue: "",
      unitLabel: "",
    },
    verticalGraphText: {
      valueLabel: "",
      dataValue: "",
      unitLabel: "",
    },
  }),
  methods: {
    exportSalesEvolutionTable: function () {
      this.$refs.salesEvolutionGraph.exportData()
    },
    exportInsigniaGraphTable: function () {
      this.$refs.insigniaGraph.exportData()
    },
    exportTreemapGraphTable: function () {
      this.$refs.treemapGraph.exportData()
    },
    clearData: function () {
      (this.selectedBarMonth = null),
        (this.selectedBarYear = null),
        (this.selectedBarInsignia = null),
        (this.selectedTreemap = null);
      this.hGraphHierarchyId = null;
      this.treemapHierarchyId = null;
    },
    selectingMonth(month) {
      this.monthPicker = false;
      this.selectedMonth = month;
      this.selectedTimePeriod = moment(this.selectedMonth, "M").format("MMMM");
      this.selectedTimePeriod =
        this.selectedTimePeriod.charAt(0).toUpperCase() +
        this.selectedTimePeriod.slice(1);
    },
    askForDataStoreRanking(event) {
      this.storeRankingPagination.page = event.pagination.page;
      this.storeRankingPagination.rowsPerPage = event.pagination.rowsPerPage;
      this.updateStoreRanking();
    },
    askForDataProductRanking(event) {
      this.productRankingPagination.page = event.pagination.page;
      this.productRankingPagination.rowsPerPage = event.pagination.rowsPerPage;
      this.updateProductRanking();
    },
    async updateStoreRanking() {
      let response = null;
      if (this.fieldId) {
        this.isLoadingStoreRanking = true;
        response = await BackendServices.kpis.getFlashReportStoreRanking(
          this.startDate,
          this.endDate,
          this.fieldId,
          this.selectedRetailer,
          this.productIds,
          this.storeIds,
          this.employeeIds,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.hGraphHierarchyId
            ? this.hGraphHierarchyId
            : this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.storeRankingPagination.page,
          this.storeRankingPagination.rowsPerPage
        );
        this.isLoadingStoreRanking = false;
        this.storeRankingData = response.data;
        this.recordsTotalStoreRanking = response.headers["x-total-count"];
      }
    },
    async updateProductRanking() {
      let response = null;
      if (this.fieldId) {
        this.isLoadingProductRanking = true;
        response = await BackendServices.kpis.getFlashReportProductRanking(
          this.startDate,
          this.endDate,
          this.fieldId,
          this.selectedRetailer,
          this.productIds,
          this.storeIds,
          this.employeeIds,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.hGraphHierarchyId
            ? this.hGraphHierarchyId
            : this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productRankingPagination.page,
          this.productRankingPagination.rowsPerPage
        );
        this.isLoadingProductRanking = false;
        this.productRankingData = response.data;
        this.recordsTotalProductRanking = response.headers["x-total-count"];
      }
    },
    updatedTimePeriod() {
      this.selectedMonth = null;
      if (this.datePeriod === CalendarServices.TIME_PERIODS.DAY) {
        this.monthPicker = true;
      } else {
        this.monthPicker = false;
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.YTD) {
        this.selectedTimePeriod = "YTD";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.MTD) {
        this.selectedTimePeriod = "MTD";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.QUARTER) {
        this.selectedTimePeriod = "Trimestre";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.MONTH) {
        this.selectedTimePeriod = "Mês";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.PROMO_WEEK) {
        this.selectedTimePeriod = "Week Promo";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.WEEK) {
        this.selectedTimePeriod = "Week Std";
      }

      if (this.datePeriod === CalendarServices.TIME_PERIODS.NIELSEN) {
        this.selectedTimePeriod = "Período Nielsen";
      }
    },
    //TODO: this should update right drawer's date fields
    updatePeriod(event) {
      let computedEndDate = null;
      if (this.datePeriod === CalendarServices.TIME_PERIODS.YTD || this.datePeriod === CalendarServices.TIME_PERIODS.MTD) {
        computedEndDate = moment(this.salesEvolution.evaluatedMainDates.end_date).year() === event.year ? moment(this.salesEvolution.evaluatedMainDates.end_date, "YYYY-MM-DD") : moment(this.salesEvolution.evaluatedSecondaryDates.end_date, "YYYY-MM-DD")
      } else {
        computedEndDate = this.endDate;
      }

      let dates = CalendarServices.intervalForPeriod(
        this.datePeriod,
        event.year,
        (this.datePeriod === CalendarServices.TIME_PERIODS.YTD || this.datePeriod === CalendarServices.TIME_PERIODS.MTD)
          ? computedEndDate.month() + 1
          : this.selectedMonth,
        computedEndDate.date(),
        event.label,
        2
      );

      if (this.datePeriod === CalendarServices.TIME_PERIODS.YTD) {
        this.selectedBarMonth = null
      } else if (this.datePeriod === CalendarServices.TIME_PERIODS.QUARTER) {
        this.selectedBarMonth = moment(dates.startDate).format("Qo");
      } else {
        this.selectedBarMonth = moment(dates.startDate).format("MMMM");
      }
      this.selectedBarYear = moment(dates.startDate).format("YYYY");

      this.$emit("update-end-date", dates.endDate);
      this.$emit("update-start-date", dates.startDate);

      this.mainHorizontalGraphKey =
        moment(this.startDate, "DD-MM-YYYY").year() - 1;
      this.secondaryHorizontalGraphKey = moment(
        this.startDate,
        "DD-MM-YYYY"
      ).year();
    },
    //TODO: this should update the drawer's store hierarchy
    updateStoreHierarchyLevel(event) {
      if (event.direction == "up") {
        this.hGraphHierarchyId = event.data.parent_id;
      } else if (event.direction == "down") {
        this.hGraphHierarchyId = event.data.store_hierarchy_id;
      }

      this.selectedBarInsignia = event.data.label;
    },
    async updateStoreHierarchy() {
      let result = {
        mainData: [],
        secondaryData: []
      };
      let primaryResponse = null;
      let secondaryResponse = null;
      this.isLoadingSalesByStore = true;
      if (this.fieldId) {
        secondaryResponse =
          await BackendServices.kpis.getChildrenAggregationByHierarchyStore(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.hGraphHierarchyId,
            this.storeHierarchyElementId,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.geoHierarchyElementId,
            this.productIds,
            this.storeIds,
            this.selectedRetailer,
            this.employeeIds,
          );
        result.secondaryData = secondaryResponse.data;

        let prevYearStartDate = moment(this.startDate).subtract(1, "year");
        let prevYearEndDate = moment(this.endDate).subtract(1, "year");
        primaryResponse =
          await BackendServices.kpis.getChildrenAggregationByHierarchyStore(
            prevYearStartDate,
            prevYearEndDate,
            this.fieldId,
            this.hGraphHierarchyId,
            this.storeHierarchyElementId,
            this.treemapHierarchyId
              ? this.treemapHierarchyId
              : this.productHierarchyElementId,
            this.geoHierarchyElementId,
            this.productIds,
            this.storeIds,
            this.selectedRetailer,
            this.employeeIds,
          );
        result.mainData = primaryResponse.data;

        if (result.mainData.length > result.secondaryData.length) {
          let a = result.mainData.map((i) => i.label);
          let b = result.secondaryData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.mainData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.secondaryData.push(obj);
          });
        } else if (result.secondaryData.length > result.mainData.length) {
          let a = result.secondaryData.map((i) => i.label);
          let b = result.mainData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.secondaryData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.mainData.push(obj);
          });
        }

        if (result.secondaryData.length > result.mainData.length) {
          let a = result.secondaryData.map((i) => i.label);
          let b = result.mainData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.secondaryData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.mainData.push(obj);
          });

          result.mainData.sort(function (a, b) {
            var textA = a.label.toUpperCase();
            var textB = b.label.toUpperCase();

            return textA.localeCompare(textB);
          });

          result.secondaryData.sort(function (a, b) {
            var textA = a.label.toUpperCase();
            var textB = b.label.toUpperCase();

            return textA.localeCompare(textB);
          });
        }
        this.isLoadingSalesByStore = false;

        this.salesByStore = result;
      }
    },
    async updateSalesEvolution() {

      if (this.datePeriod === 'day' && this.selectedMonth === null) {
        return;
      }

      let result = {
        mainData: null,
        secondaryData: null,
      };

      this.mainVerticalGraphKey = this.endDate.year() - 1;
      this.secondaryVerticalGraphKey = this.endDate.year();
      if (this.fieldId) {
        this.isLoadingSalesEvolution = true;
        let mainResponse = await BackendServices.kpis.getSalesByPeriod(
          this.datePeriod,
          this.endDate.year() - 1,
          this.datePeriod === "day"
            ? this.selectedMonth
            : this.datePeriod === "ytd" || this.datePeriod === "mtd"
              ? this.endDate.month() + 1
              : null,
          this.datePeriod === "ytd" || this.datePeriod === "mtd" ? this.endDate.date() : null,
          this.fieldId,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.hGraphHierarchyId
            ? this.hGraphHierarchyId
            : this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.selectedRetailer,
          this.employeeIds,
        );
        result.mainData = mainResponse.data.result;
        let secondaryResponse = await BackendServices.kpis.getSalesByPeriod(
          this.datePeriod,
          this.endDate.year(),
          this.datePeriod === "day"
            ? this.selectedMonth
            : this.datePeriod === "ytd" || this.datePeriod === "mtd"
              ? this.endDate.month() + 1
              : null,
          this.datePeriod === "ytd" || this.datePeriod === "mtd" ? this.endDate.date() : null,
          this.fieldId,
          this.treemapHierarchyId
            ? this.treemapHierarchyId
            : this.productHierarchyElementId,
          this.hGraphHierarchyId
            ? this.hGraphHierarchyId
            : this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.selectedRetailer,
          this.employeeIds,
          true,
        );
        result.secondaryData = secondaryResponse.data.result;

        if (this.datePeriod === "ytd" || this.datePeriod === "mtd") {
          result.mainData = [mainResponse.data.result[0]];
          // result.secondaryData = [mainResponse.data.result[1]];
        }

        if (result.mainData.length > result.secondaryData.length) {
          let a = result.mainData.map((i) => i.label);
          let b = result.secondaryData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.mainData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.secondaryData.push(obj);
          });
        } else if (result.secondaryData.length > result.mainData.length) {
          let a = result.secondaryData.map((i) => i.label);
          let b = result.mainData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.secondaryData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.mainData.push(obj);
          });
        }

        if (result.mainData.length > result.secondaryData.length) {
          let a = result.mainData.map((i) => i.label);
          let b = result.secondaryData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.mainData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.secondaryData.push(obj);
          });
        } else if (result.secondaryData.length > result.mainData.length) {
          let a = result.secondaryData.map((i) => i.label);
          let b = result.mainData.map((i) => i.label);
          let missingKeys = a.filter((i) => b.indexOf(i) < 0);
          missingKeys.forEach((key) => {
            let obj = {
              ...result.secondaryData.filter((i) => i.label === key).pop(),
            };
            obj.value = 0;
            result.mainData.push(obj);
          });
        }

        this.salesEvolution = result;
        this.salesEvolution.evaluatedMainDates = mainResponse.data.evaulatedDates
        this.salesEvolution.evaluatedSecondaryDates = secondaryResponse.data.evaulatedDates
        this.salesEvolution.lineData = this.salesEvolutionVariation;
        this.isLoadingSalesEvolution = false; //Just for testing
      }
    },
    drillTreemap(event) {
      if (event.direction === "down") {
        this.treemapHierarchyId = event.data.product_hierarchy_id;
        this.selectedTreemap = event.data.label;
      } else if (event.direction === "up") {
        this.treemapHierarchyId = event.data.parent_id;
        this.selectedTreemap = event.data.parent_label;
      }
    },
    showTreeMapHierarchy(event) {
      this.treeMapSelectedText = event;
    },
    showVerticaGraphData(event) {
      this.verticalGraphText = event;
    },
    async updateProductHierarchyAggregation() {
      this.treeMapLoading = true;
      let response = null;
      if (this.fieldId) {
        response =
          await BackendServices.kpis.getChildrenAggregationByHierarchyElement(
            this.startDate,
            this.endDate,
            this.fieldId,
            this.treemapHierarchyId,
            this.productHierarchyElementId,
            this.hGraphHierarchyId
              ? this.hGraphHierarchyId
              : this.storeHierarchyElementId,
            this.geoHierarchyElementId,
            this.productIds,
            this.storeIds,
            this.employeeIds,
            this.selectedRetailer
          );

        if (response.data.length > 0) {
          this.showTreeMap = true;
        } else {
          this.showTreeMap = false;
        }
        this.productAggregationData.children = response.data.filter(
          (item) => item.value
        );
      }
      this.treeMapLoading = false;
    },
    async getFRStoreRankingExport() {
      let response = null;
      this.export = Boolean(true);
      response = await BackendServices.kpis.getFlashReportStoreRankingExport(
        this.startDate,
        this.endDate,
        this.fieldId,
        this.selectedRetailer,
        this.productIds,
        this.storeIds,
        this.employeeIds,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.hGraphHierarchyId
          ? this.hGraphHierarchyId
          : this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.storeRankingPagination.page,
        this.storeRankingPagination.rowsPerPage,
        this.export
      );

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    async getFRProductRankingExport() {
      let response = null;
      this.export = Boolean(true);
      response = await BackendServices.kpis.getFlashReportProductRankingExport(
        this.startDate,
        this.endDate,
        this.fieldId,
        this.selectedRetailer,
        this.productIds,
        this.storeIds,
        this.employeeIds,
        this.treemapHierarchyId
          ? this.treemapHierarchyId
          : this.productHierarchyElementId,
        this.hGraphHierarchyId
          ? this.hGraphHierarchyId
          : this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productRankingPagination.page,
        this.productRankingPagination.rowsPerPage,
        this.export
      );

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  },
  computed: {
    hasMultipleRetailers: function () {
      try {
        let selectedRetailers = this.$store.getters.getStoreHierarchy.retalhista;
        if (Array.isArray(selectedRetailers) && selectedRetailers.length > 1) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }


    },
    selectedMetric() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field ? field.button_label : undefined;
    },
    selectedMetricName() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field && field.name_label !== null ? field.name_label : '';
    },
    selectedMetricUnit() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field && field.unit_label !== null ? field.unit_label : '';
    },
    salesFieldsButtonGroup() {
      return this.fields.map((i) => ({
        label: i.button_label !== null ? i.button_label : '',
        value: i.id
      }));
    },
    kpiUnits() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field ? field.unit_label : undefined;
    },
    selectedRetailerName: function () {
      let retailer = this.retailerList.find(
        (i) => i.id === this.selectedRetailer
      );
      return retailer ? retailer.name : null;
    },
    salesEvolutionVariation: function () {
      if (this.salesEvolution.secondaryData.length === 0 || this.salesEvolution.mainData.length === 0) {
        return [];
      }
      let a = this.salesEvolution.secondaryData.map((obj, i) =>
        (!this.salesEvolution.mainData[i].value || !obj.value) ?
          [i, null] :
          [i, (obj.value / this.salesEvolution.mainData[i].value - 1) * 100]
      )
      return a.filter(e => e[1] != null);
    },
  },
  watch: {
    fieldId: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    // selectedRetailer: {
    //   deep: true,
    //   immediate: true,
    //   handler: function () {
    //     if (this.selectedRetailer.length != 1 && this.datePeriod === "promo_week") {
    //       this.datePeriod = this.CalendarServices.TIME_PERIODS.MONTH;
    //       this.updatedTimePeriod();
    //     }
    //   },
    // },
    productHierarchyElementId: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    treemapHierarchyId: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    storeHierarchyElementId: {
      immediate: true,
      handler: function () {
        if (Array.isArray(this.selectedRetailer) && this.selectedRetailer.length != 1 && this.datePeriod === "promo_week") {
          this.datePeriod = this.CalendarServices.TIME_PERIODS.MONTH;
          this.updatedTimePeriod();
        }
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    hGraphHierarchyId: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    geoHierarchyElementId: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
        this.updateStoreHierarchy();
        this.updateProductRanking();
        this.updateStoreRanking();
      },
    },
    startDate: {
      immediate: true,
      handler: function () {
        if (this.startDate.isValid()) {
          this.updateProductHierarchyAggregation();
          this.updateStoreHierarchy();
          this.updateStoreRanking();
          this.updateProductRanking();
        }
      },
    },
    endDate: {
      immediate: true,
      handler: function () {
        if (this.endDate.isValid()) {
          this.updateSalesEvolution();
          this.updateProductHierarchyAggregation();
          this.updateStoreHierarchy();
          this.updateStoreRanking();
          this.updateProductRanking();
        }
      },
    },
    selectedMonth: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
      },
    },
    datePeriod: {
      immediate: true,
      handler: function () {
        this.updateSalesEvolution();
      },
    },
    productIds: {
      immediate: true,
      handler: function () {
        this.updateStoreRanking();
        this.updateProductRanking();
        this.updateStoreHierarchy();
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
      },
    },
    storeIds: {
      immediate: true,
      handler: function () {
        this.updateStoreRanking();
        this.updateProductRanking();
        this.updateStoreHierarchy();
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
      },
    },
    employeeIds: {
      immediate: true,
      handler: function () {
        this.updateStoreRanking();
        this.updateProductRanking();
        this.updateStoreHierarchy();
        this.updateSalesEvolution();
        this.updateProductHierarchyAggregation();
      },
    },
  },
};
